var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ruleSet"},[_c('div',{staticClass:"leftSlider"},[_c('ruleLeft',{on:{"setCurrentRule":_vm.setCurrentRule}})],1),_c('div',{staticClass:"rightSlider"},[_c('ruleRight',{ref:"ruleSetRight"})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }